import api from '@/factories/api';

export default {
  namespaced: true,
  actions: {
    sendCustomEvent({ commit, state }, data) {
      api().post('cg/event', data);
    },
  },
};
